import "vuetify/styles";
import { createVuetify } from "vuetify";
import { fr } from "vuetify/locale";
import { getStoredThemePreference } from "@/services/Theme.service";

// Components and directives are imported on demand by webpack-plugin-vuetify (vue.config.js).
export default createVuetify({
  // Built-in component texts (tables, date pickers, ...) in French
  locale: {
    locale: "fr",
    messages: { fr },
  },
  theme: {
    // Vuetify 4 follows the device ("system") by default; the site stays light unless the user picks
    // another theme (ThemeSelector.vue)
    defaultTheme: getStoredThemePreference(),
    // Generates the lighten/darken shades of the theme colors (e.g. bg-primary-lighten-4, primary-darken-1)
    variations: {
      colors: ["primary", "secondary"],
      lighten: 5,
      darken: 4,
    },
    // Colours of our own (section-river, table-header, ...) get bg-*, text-* and on-* classes in both
    // themes, so components use those classes instead of fixed grey or blue shades.
    // Québec Eau Vive brand colours (docs/BRAND.md): Marine #0B3C5D, Eau #1F8FA6, Écume #8FD3E0, Or #E0A526. Eau is too
    // light for white text (3.8:1), so buttons use the Eau #1A7E92 and text the darker Eau #14707F; every text pair
    // below is at least 4.5:1.
    themes: {
      light: {
        colors: {
          // Ordinary buttons and links in Eau
          primary: "#1A7E92",
          secondary: "#424242",
          accent: "#1F8FA6",
          // Gold: one call-to-action per screen (with Marine text), the "now" mark, favourites, special badges.
          // Never for a level, so it can't be mistaken for red, green or blue.
          gold: "#E0A526",
          "on-gold": "#0B3C5D",
          // Gold text on white, and the pale gold of the badges
          "gold-text": "#9A6B00",
          "gold-tint": "#FBF1D9",
          "on-gold-tint": "#7A5300",
          // Levels: low, good (recommended), high. Text shades, darker than the marker colours where needed
          "level-low": "#C23A3A",
          "level-good": "#237A44",
          "level-high": "#1F6FD1",
          // Community dangers: a softer, deeper red than `error` (#FF5252), readable with white text (4.8:1)
          danger: "#C8463D",
          "on-danger": "#FFFFFF",
          error: "#FF5252",
          info: "#2196F3",
          success: "#4CAF50",
          warning: "#FFC107",
          // The app bar stays Marine in both themes
          "app-bar": "#0B3C5D",
          "on-app-bar": "#FFFFFF",
          // Page toolbars and the section tabs, under the app bar
          "page-toolbar": "#14707F",
          "on-page-toolbar": "#FFFFFF",
          "page-toolbar-accent": "#8FD3E0",
          "on-page-toolbar-accent": "#0B3C5D",
          "table-header": "#CDEBF1",
          // grey-darken-3 and darker Eau of the section rows, grey-lighten-2 for the inactive content icons
          "section-river": "#424242",
          "section-name": "#14707F",
          "icon-inactive": "#E0E0E0",
          // The top of the drop
          "primary-tint": "#E3F1F5",
        },
      },
      // Light Eau on the deep navy: buttons get dark text, links stay readable on the surfaces
      dark: {
        colors: {
          background: "#0F1720",
          surface: "#17212C",
          "surface-bright": "#22303F",
          "surface-light": "#2A3847",
          primary: "#5BC0D3",
          "on-primary": "#0B2530",
          secondary: "#90A4AE",
          accent: "#8FD3E0",
          gold: "#E8B23A",
          "on-gold": "#0B3C5D",
          "gold-text": "#E8B23A",
          "gold-tint": "#3A2F14",
          "on-gold-tint": "#F3D58A",
          "level-low": "#F07070",
          "level-good": "#5CC984",
          "level-high": "#6AA6F0",
          danger: "#E57A70",
          "on-danger": "#2A0E0B",
          error: "#FF5252",
          info: "#42A5F5",
          success: "#66BB6A",
          warning: "#FFC107",
          "app-bar": "#0B2E47",
          "on-app-bar": "#FFFFFF",
          "page-toolbar": "#173C4D",
          "on-page-toolbar": "#FFFFFF",
          "page-toolbar-accent": "#8FD3E0",
          "on-page-toolbar-accent": "#0B3C5D",
          "table-header": "#173C4D",
          "section-river": "#E3E8EE",
          "section-name": "#8FD3E0",
          "icon-inactive": "#3A4756",
          "primary-tint": "#14303B",
        },
      },
    },
  },
});
